

$(function(){

    if ( $('.sustainability.our-social-goods').length == 0 ) {
        return;
    }

    let active_tab = null;

    $('.nav-ge-tab .nav-link').click(function(e){

        e.preventDefault();

        if( $(this).is(active_tab)) {
            return;
        }

        if( active_tab  ) {
            active_tab.removeClass('active');
        }

        active_tab = $(this);

        $(this).addClass('active');

        let type = $(this).data('option');

        let locale = $('html').attr('lang');
        let url = '';
        if ( locale === 'en' ) {
            url = `/our-social-goods-blocks`;
        } else {
            url = `/${locale}/our-social-goods-blocks`;
        }

        $('#sustainable-blocks').html("").load( url, { 'type' : type });

    });

    $('.nav-ge-tab .nav-link').first().trigger('click');

});
